module.exports = __webpack_public_path__ + "img/logo-openagent-green-grey.facb03e8.svg";